import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

const Footer: FC<{
  bundleData: any;
  step: number;
  formValidity: boolean;
}> = (props) => {
  // ! React router
  const navigate = useNavigate();

  const formSubmitHandler = () => {
    navigate("/offers");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__price">
          <span className="text--tertiary">
            Price starts at: {/* TODO: fix */}
          </span>
          <span className="heading heading--tertiary">
            {props.bundleData &&
            typeof props.bundleData[0].price === "number" &&
            props.formValidity
              ? `$${props.bundleData[0]?.price}`
              : "-- $"}
          </span>
        </div>

        <button
          className="cta cta--primary footer__cta"
          type="button"
          disabled={!props.formValidity}
          onClick={() => formSubmitHandler()}
        >
          Show offers
        </button>
      </div>
    </footer>
  );
};

export default Footer;
